import { View, Text, Platform, I18nManager } from "react-native";
import React from "react";
import Cookies from "universal-cookie";
import { useSelector } from "react-redux";
const cookies = new Cookies();

export default function MyText(props) {
  const main = useSelector((state) => state.main);
  let persianNumber = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  function correctNumber(text) {
    if (!main.rtl || props.noCorrection !== undefined) {
      if (text === null || text === undefined || text.split === undefined) {
        return "";
      }
      return text;
    }
    if (text === null || text === undefined || text.split === undefined) {
      return "";
    }
    let chars = text.split("");
    for (let i = 0; i < chars.length; i++) {
      if (/\d/.test(chars[i])) {
        chars[i] = persianNumber[chars[i]];
      }
    }
    return chars.join("");
  }
  if (Platform.OS !== "web") {
    return (
      <Text
        numberOfLines={props.numberOfLines}
        ellipsizeMode="tail"
        style={[
          {
            fontFamily:
              props.fontFamily !== undefined
                ? props.fontFamily
                : main.rtl
                ? "main"
                : null,
            writingDirection: main.rtl ? "rtl" : "ltr",
            direction: main.rtl ? "rtl" : "ltr",

            flexWrap: "wrap",

            letterSpacing: 1.4,
          },
          props.style,
          {
            fontSize:
              props.style !== undefined && props.style.fontSize !== undefined
                ? main.rtl
                  ? props.style.fontSize
                  : props.style.fontSize
                : main.rtl
                ? 15
                : 15,
          },
        ]}
      >
        {correctNumber(props.children)}
      </Text>
    );
  } else {
    return (
      <Text
        numberOfLines={props.numberOfLines}
        ellipsizeMode="tail"
        style={[
          {
            fontFamily:
              props.fontFamily !== undefined
                ? props.fontFamily
                : main.rtl
                ? "main"
                : null,
            writingDirection: main.rtl ? "rtl" : "ltr",
            direction: main.rtl ? "rtl" : "ltr",
            fontSize: 15,

            flexWrap: "wrap",
          },
          props.style,
        ]}
      >
        {correctNumber(props.children)}
      </Text>
    );
  }
}
